module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "main"
  }, [_c('div', {
    attrs: {
      "id": "container"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "little-title"
  }, [_vm._v(_vm._s(_vm.$t('aboutUs')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('company')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('concentrate')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('wish')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "contact-us"
  }, [_c('p', {
    staticClass: "little-title"
  }, [_vm._v(_vm._s(_vm.$t('contactUs')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('email')) + "  iplexservice@gmail.com")])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d17e6c3e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/aboutUs/AboutUs.vue
// module id = 1393
// module chunks = 1